import './../main.js'
import { createApp } from 'vue'

import MasterLoader from './apps/MasterLoader.vue'
import PlayingNowStrip from './apps/PlayingNowStrip.vue'
import NewsCardsSlide from './apps/NewsCardsSlide.vue'
import ImageSlide from './apps/ImageSlide.vue'
import ComingSoonStrip from './apps/ComingSoonStrip.vue'
import HeroSliderStrip from './apps/HeroSliderStrip.vue'
import NewsTabs from './apps/NewsTabs.vue'
import MiddleVideo from './apps/MiddleVideo.vue'
import SearchModal from './apps/SearchModal.vue'
import QuickBookingStrip from './apps/QuickBookingStrip.vue'
import BookingApp from './apps/BookingApp.vue'
import PreOrderStripApp from './apps/PreOrderStripApp.vue'
import { clickOutside } from '../directives/vClickOutside.js'
import BookingRoutes from './routers/bookingRouter.js'
import BreadcrumbApp from './apps/BreadcrumbApp.vue'
import CreateVoucherApp from './apps/CreateVoucherApp.vue'
import MovieOverviewApp from './apps/MovieOverviewApp.vue'
import ChangeAvatarApp from './apps/ChangeAvatarApp.vue'
import TrailerStandAloneApp from './apps/TrailerStandAloneApp.vue'
import SingleReminderStripApp from './apps/SingleReminderStripApp.vue'
import ComingSoonPage from './apps/ComingSoonPage.vue'
import NewsSubscribeForm from './apps/NewsSubscribeForm.vue'
import PreBookingStepApp from './apps/PreBookingStepApp.vue'
import ContactFormApp from './apps/ContactFormApp.vue'
import EditUserProfileFormApp from './apps/EditUserProfileFormApp.vue'
import LoginModal from './apps/LoginModal.vue'
import PasswordReminderFormApp from './apps/PasswordReminderFormApp.vue'
import ProfileMembershipApp from './apps/ProfileMembershipApp.vue'
import PasswordResetFormApp from './apps/PasswordResetFormApp.vue'
import ShopCafe from './apps/ShopCafe.vue'
import SinglePayment from './apps/SinglePayment.vue'
import FamilyClubUserRegisterCompleteFormApp from './apps/FamilyClubUserRegisterCompleteFormApp.vue'
import FamilyClubUserRegisterConfirmEmailFormApp from './apps/FamilyClubUserRegisterConfirmEmailFormApp.vue'
import MyPurchases from './apps/MyPurchases.vue'
import MovieSnapshots from './apps/MovieSnapshots.vue'
import VipRegisterForm from './apps/VIPRegisterForm.vue'
import ContestRegistrationFormApp from './apps/ContestRegistrationFormApp.vue'

import { createPinia } from 'pinia'

if (document.getElementById('master-loader')) {
  const app = createApp(MasterLoader)
  app.mount('#master-loader')
}

// playing-now-strip-app
if (document.getElementById('playing-now-strip-app')) {
  const { dictionary, configuration } = window['nowPlayingData']
  const app = createApp(PlayingNowStrip)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#playing-now-strip-app')
}

if (document.querySelectorAll('[id^="multiple-card-slider-app"]').length) {
  document
    .querySelectorAll('[id^="multiple-card-slider-app"]')
    .forEach((cardsItem) => {
      const suffix = cardsItem.id.replace('multiple-card-slider-app-', '')
      const { dictionary, configuration } =
        window[`multiCardSliderData${suffix}`]
      const app = createApp(NewsCardsSlide)
      Object.assign(
        app.config.globalProperties,
        { dictionary: dictionary },
        { configuration: configuration },
        { suffix: suffix }
      )
      app.mount(`#${cardsItem.id}`)
    })
}

if (document.querySelectorAll('[id^="multiple-image-slider-app"]').length) {
  document
    .querySelectorAll('[id^="multiple-image-slider-app"]')
    .forEach((galleryItem) => {
      const suffix = galleryItem.id.replace('multiple-image-slider-app-', '')
      const { dictionary, configuration } =
        window[`multiImageSliderData${suffix}`]
      const app = createApp(ImageSlide)
      Object.assign(
        app.config.globalProperties,
        { dictionary: dictionary },
        { configuration: configuration },
        { suffix: suffix }
      )
      app.mount(`#${galleryItem.id}`)
    })
}

if (document.querySelectorAll('[id^="multiple-slider-app"]').length) {
  document
    .querySelectorAll('[id^="multiple-slider-app"]')
    .forEach((galleryItem) => {
      const suffix = galleryItem.id.replace('multiple-slider-app-', '')
      const { dictionary, configuration } = window[`multiSliderData${suffix}`]
      const app = createApp(MovieSnapshots)
      Object.assign(
        app.config.globalProperties,
        { dictionary: dictionary },
        { configuration: configuration },
        { suffix: suffix }
      )
      app.mount(`#${galleryItem.id}`)
    })
}

// coming-soon-strip-app
if (document.getElementById('coming-soon-strip-app')) {
  const { dictionary, configuration } = window['comingSoonStripData']
  const app = createApp(ComingSoonStrip)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#coming-soon-strip-app')
}

// coming-soon-strip-app
if (document.getElementById('coming-soon-page-app')) {
  const app = createApp(ComingSoonPage)

  app.mount('#coming-soon-page-app')
}

// featured-header-strip-app
if (document.getElementById('hero-slider-strip-app')) {
  const { dictionary, configuration } = window['heroSliderStripData']
  const app = createApp(HeroSliderStrip)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#hero-slider-strip-app')
}

if (document.getElementById('news-tabs-strip-app')) {
  const { dictionary, configuration } = window['NewsTabsData']
  const app = createApp(NewsTabs)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#news-tabs-strip-app')
}

// middle Video
if (document.getElementById('middle-video-app')) {
  const { dictionary, configuration } = window['middleVideoData']
  const app = createApp(MiddleVideo)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#middle-video-app')
}

// search modal app
const SearchModalId = 'search-modal-app'
if (document.getElementById(SearchModalId)) {
  const { dictionary, configuration } = window['searchModalData']
  const app = createApp(SearchModal)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount(`#${SearchModalId}`)
}

// quick booking app
const QuickBookingId = 'quick-booking-app'
if (document.getElementById(QuickBookingId)) {
  const { dictionary, configuration } = window['quickBookingData']
  const app = createApp(QuickBookingStrip)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )
  app.directive('clickOutside', clickOutside)
  app.mount(`#${QuickBookingId}`)
}

// booking app
const BookingAppId = 'booking-app'
if (document.getElementById(BookingAppId)) {
  const { dictionary, configuration } = window['bookingData']
  const app = createApp(BookingApp)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )
  app.use(BookingRoutes)
  app.use(createPinia())
  app.mount(`#${BookingAppId}`)
}

// pre order app
const PreOrderAppId = 'pre-order-strip-app'
if (document.getElementById(PreOrderAppId)) {
  const { dictionary, configuration } = window['preOrderData']
  const app = createApp(PreOrderStripApp)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )
  app.mount(`#${PreOrderAppId}`)
}

// breadcrumb app
const breadcrumbAppId = 'breadcrumb-app'
if (document.getElementById(breadcrumbAppId)) {
  const { dictionary, configuration } = window['breadcrumbData']
  const app = createApp(BreadcrumbApp)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )
  app.mount(`#${breadcrumbAppId}`)
}

// create voucher app
const CreateVoucherAppId = 'create-voucher-app'
if (document.getElementById(CreateVoucherAppId)) {
  const { dictionary, configuration } = window['createVoucherData']
  const app = createApp(CreateVoucherApp)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )
  app.mount(`#${CreateVoucherAppId}`)
}

// create voucher app
const MovieOverviewAppId = 'movie-overview-app'
if (document.getElementById(MovieOverviewAppId)) {
  const { dictionary, configuration } = window['movieOverviewData']
  const app = createApp(MovieOverviewApp)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )
  app.mount(`#${MovieOverviewAppId}`)
}

// ChangeAvatarApp
if (document.getElementById('change-avatar-app')) {
  const { dictionary, configuration } = window['changeAvatarData']
  const app = createApp(ChangeAvatarApp)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#change-avatar-app')
}

// TrailerStandAloneApp
if (document.getElementById('trailer-stand-alone-app')) {
  const app = createApp(TrailerStandAloneApp)
  app.mount('#trailer-stand-alone-app')
}

// SingleReminderStripApp
if (document.getElementById('single-reminder-app')) {
  const { dictionary, configuration } = window['comingSoonStripData']
  const app = createApp(SingleReminderStripApp)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#single-reminder-app')
}

// ContactFormApp
if (document.getElementById('contact-form-app')) {
  const { dictionary, configuration } = window['contactFormAppData']
  const app = createApp(ContactFormApp)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#contact-form-app')
}

// EditUserProfileFormApp
if (document.getElementById('edit-user-profile-form-app')) {
  const { dictionary, configuration } = window['editUserProfileFormAppData']
  const app = createApp(EditUserProfileFormApp)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#edit-user-profile-form-app')
}

// ProfileReminderFormApp
if (document.getElementById('password-reminder-form-app')) {
  const { dictionary, configuration } = window['passwordReminderFormAppData']
  const app = createApp(PasswordReminderFormApp)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#password-reminder-form-app')
}

// ProfileMembershipApp
if (document.getElementById('profile-membership-app')) {
  const { dictionary, configuration } = window['profileMembershipAppData']
  const app = createApp(ProfileMembershipApp)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#profile-membership-app')
}

// PasswordResetFormApp
if (document.getElementById('password-reset-form-app')) {
  const { dictionary, configuration } = window['passwordResetFormAppData']
  const app = createApp(PasswordResetFormApp)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#password-reset-form-app')
}

// FamilyClubUserRegisterCompleteFormApp
if (document.getElementById('family-club-user-register-complete-form-app')) {
  const { dictionary, configuration } =
    window['familyClubUserRegisterCompleteFormAppData']
  const app = createApp(FamilyClubUserRegisterCompleteFormApp)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#family-club-user-register-complete-form-app')
}

// FamilyClubUserRegisterConfirmEmailFormApp
if (
  document.getElementById('family-club-user-register-confirm-email-form-app')
) {
  const { dictionary, configuration } =
    window['familyClubUserRegisterConfirmEmailFormAppData']
  const app = createApp(FamilyClubUserRegisterConfirmEmailFormApp)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#family-club-user-register-confirm-email-form-app')
}

// news-letter-form
const NewsSubscribeFormId = 'news-subscribe-form'
if (document.getElementById(NewsSubscribeFormId)) {
  const { dictionary, configuration } = window['newsLetterFormData']
  const app = createApp(NewsSubscribeForm)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount(`#${NewsSubscribeFormId}`)
}

// pre-booking-step for movie details page
const PreBookingStepAppId = 'pre-booking-step-app'
if (document.getElementById(PreBookingStepAppId)) {
  const { dictionary, configuration } = window['movieDetailsData']
  const app = createApp(PreBookingStepApp)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )
  app.use(createPinia())
  app.mount(`#${PreBookingStepAppId}`)
}

// login modal
if (document.getElementById('login-modal-app')) {
  const { dictionary, configuration } = window['loginModalData']
  const app = createApp(LoginModal)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )
  app.use(createPinia())

  app.mount('#login-modal-app')
}

const ShopCafeId = 'shopping-cafe-app'
if (document.getElementById(ShopCafeId)) {
  const { dictionary, configuration } = window['shoppingCafeData']
  const app = createApp(ShopCafe)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )
  app.use(createPinia())
  app.mount(`#${ShopCafeId}`)
}

const SinglePaymentId = 'single-payment-app'
if (document.getElementById(SinglePaymentId)) {
  const { dictionary, configuration } = window['singlePaymentData']
  const app = createApp(SinglePayment)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )
  app.use(createPinia())
  app.mount(`#${SinglePaymentId}`)
}

if (document.getElementById('app-my-purchases')) {
  const { dictionary, configuration } = window['myPurchasesData']
  const app = createApp(MyPurchases)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-my-purchases')
}

if (document.getElementById('vip-register-form')) {
  const { dictionary, configuration } = window['vipRegisterForm']
  const app = createApp(VipRegisterForm)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#vip-register-form')
}

// Contest Registration Form
if (document.getElementById('contest-registration-form-app')) {
  const { dictionary, configuration } = window['contestRegistrationFormData']
  const app = createApp(ContestRegistrationFormApp)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#contest-registration-form-app')
}

jQuery('.master-loader').remove()
